import React from 'react';

import { ShareHelper } from '../../helpers';
import { buildListingBroadcastMessage } from '../../listings/helpers';
import { useEntitlement } from '../../contexts';
import { Icon, IconButton } from '../../components/ui';
import { WhatsAppIcon } from '../../components/ContactLinks';
import { useSendToWhatsApp, listingSubject } from '../../waBroadcast';
import { storeCaption } from '../../waBroadcast/waBroadcastApi';

const ShareToBroadcast = ({ listing }) => {
  // "Share via WhatsApp" (key share_to_broadcast): Send via WhatsApp.
  const canShare = useEntitlement('share_to_broadcast');
  // "WhatsApp Broadcast" (key wa_shared_number): Share to Broadcast.
  const wa = useSendToWhatsApp();

  const share = async () => {
    // The store's own template when it has one (Owner Admin → Message templates).
    ShareHelper.whatsapp(await storeCaption("listing", listing.id, buildListingBroadcastMessage(listing)));
  };

  return (
    <>
      {canShare && (
        <IconButton size="lg" label="Send via WhatsApp" onClick={() => share()} data-btn="listing-share">
          <WhatsAppIcon />
        </IconButton>
      )}
      {wa.canSend(listing) && (
        <IconButton
          size="lg"
          label="Share to Broadcast"
          title="Share to Broadcast"
          onClick={() => wa.open(listingSubject(listing))}
          data-btn="listing-broadcast"
        >
          <Icon name="Send" size="md" />
        </IconButton>
      )}
      {wa.sheet}
    </>
  );
}

export default ShareToBroadcast;
